// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
   list-style: none;
   margin: 0;
   padding: 0;
}

li {
   line-height: 20px;
   margin-bottom: 10px;
   position: relative;
}

.section-break {
   height: 20px;
}

li.section {
   font-weight: bold;
   padding: 5px 5px 5px 20px;
}

a, .topic {
   color: #666;
   display: inline-block;
   line-height: 20px;
   margin-left: 45px;
   padding: 5px 5px 0;
   position: relative;
}

a:hover {
   color: #ffa726;
}

a.active {
   color: #ff8326;
   cursor: initial;
}

a.active:hover {
   text-decoration: none;
}

i, .mat-icon {
   font-size: 18px;
   line-height: 20px;
   text-align: center;
   width: 20px;
   position: absolute;
   left: -20px;
   top: 0;
}

img {
   width: 22px;
   height: 22px;
   position: absolute;
   left: -22px;
   top: 4px;
}

.sub_tasks {
   padding-left: 16px;
}

i.fa-briefcase {
   font-size: 16px;
}

i:not(.caret):before {
   vertical-align: middle;
}

i.caret {
   cursor: default;
   font-size: inherit;
   left: 3px;
   top: 7px;
}

i.expanded {
   transform: rotate(90deg);
}

app-folders {
   display: block;
   margin-left: 16px;
   margin-bottom: 10px;
}

app-google-drive-folders {
   display: block;
   margin-left: 16px;
   margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/dms-menu/dms-menu.component.css"],"names":[],"mappings":"AAAA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;;AAEA;GACG,iBAAiB;GACjB,mBAAmB;GACnB,kBAAkB;AACrB;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,iBAAiB;GACjB,yBAAyB;AAC5B;;AAEA;GACG,WAAW;GACX,qBAAqB;GACrB,iBAAiB;GACjB,iBAAiB;GACjB,kBAAkB;GAClB,kBAAkB;AACrB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,eAAe;GACf,iBAAiB;GACjB,kBAAkB;GAClB,WAAW;GACX,kBAAkB;GAClB,WAAW;GACX,MAAM;AACT;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,WAAW;GACX,QAAQ;AACX;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,eAAe;GACf,kBAAkB;GAClB,SAAS;GACT,QAAQ;AACX;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,cAAc;GACd,iBAAiB;GACjB,mBAAmB;AACtB;;AAEA;GACG,cAAc;GACd,iBAAiB;GACjB,mBAAmB;AACtB","sourcesContent":["ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n\nli {\n   line-height: 20px;\n   margin-bottom: 10px;\n   position: relative;\n}\n\n.section-break {\n   height: 20px;\n}\n\nli.section {\n   font-weight: bold;\n   padding: 5px 5px 5px 20px;\n}\n\na, .topic {\n   color: #666;\n   display: inline-block;\n   line-height: 20px;\n   margin-left: 45px;\n   padding: 5px 5px 0;\n   position: relative;\n}\n\na:hover {\n   color: #ffa726;\n}\n\na.active {\n   color: #ff8326;\n   cursor: initial;\n}\n\na.active:hover {\n   text-decoration: none;\n}\n\ni, .mat-icon {\n   font-size: 18px;\n   line-height: 20px;\n   text-align: center;\n   width: 20px;\n   position: absolute;\n   left: -20px;\n   top: 0;\n}\n\nimg {\n   width: 22px;\n   height: 22px;\n   position: absolute;\n   left: -22px;\n   top: 4px;\n}\n\n.sub_tasks {\n   padding-left: 16px;\n}\n\ni.fa-briefcase {\n   font-size: 16px;\n}\n\ni:not(.caret):before {\n   vertical-align: middle;\n}\n\ni.caret {\n   cursor: default;\n   font-size: inherit;\n   left: 3px;\n   top: 7px;\n}\n\ni.expanded {\n   transform: rotate(90deg);\n}\n\napp-folders {\n   display: block;\n   margin-left: 16px;\n   margin-bottom: 10px;\n}\n\napp-google-drive-folders {\n   display: block;\n   margin-left: 16px;\n   margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
